<template>
<!--  <div v-if="pageState == 1" class="mainContainer">-->
<!--    <div class="nav">-->
<!--      <el-form :model="searchForm" label-width="120px" :inline="true">-->
<!--        <el-form-item label="标题：">-->
<!--          <el-input v-model="searchForm.title" size="mini" placeholder="请输入标题" />-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>-->
<!--          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>-->
<!--          <el-button size="small" class="searchBtn" @click="addBtn">新增</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--    </div>-->
<!--    <el-row>-->
<!--      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">-->
<!--        <div style="display: flex; justify-content: flex-end">-->
<!--          <span @click="exportData">导出</span>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
<!--    <div class="content">-->
<!--      <el-table ref="registerTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" @selection-change="selectionChange" :row-style="rowStyle">-->
<!--        <el-table-column type="selection" align="center" width="50" />-->
<!--        <el-table-column label="标题" prop="customer" />-->
<!--        <el-table-column label="操作" fixed="right" width="300" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)">详情 </el-button>-->
<!--            <el-button size="mini" class="yellow-bg" @click="btnClick('edit', scope.row)">修改 </el-button>-->
<!--            <el-button size="mini" class="resetBtn" @click="btnClick('delete', scope.row)">删除 </el-button>-->
<!--            <el-button size="mini" class="yellow-bg" @click="btnClick('edit', scope.row)">修改标题 </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </el-table>-->
<!--      <div class="paginationContainer">-->
<!--        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div v-if="pageState === 2" class="mainContainer" v-loading="tableLoading">
    <el-page-header title="" @back="goBack" content="计划表" style="margin: 10px 0">
      <template #content>
        <div>
          <div class="Btn">
            <el-button type="primary" size="mini" @click="handleChangeActiveState"  v-if="!tableActiveState && !isShowBtn">编辑</el-button>
            <el-button type="success" size="mini" @click="handleChangeActiveState" v-if="tableActiveState && !isShowBtn">取消编辑</el-button>
            <el-button @click="handleClickAddBrand" type="primary" size="mini" v-if="!brandHeaders.length && !isShowBtn">新增品牌</el-button>
            <el-button @click="handleClickUpdateBrand" type="primary" size="mini" v-if="brandHeaders.length && !isShowBtn">修改品牌</el-button>
          </div>
          <div>
            <el-button @click="handleClickSave" size="small" type="primary" :loading="loading" style="margin-top: 10px"  v-if="tableActiveState">保存</el-button>
          </div>
        </div>
      </template>
    </el-page-header>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <div style="display: flex; justify-content: flex-end">
          <span style="font-size: 16px" @click="exportData">导出</span>
        </div>
      </el-col>
    </el-row>
    <el-table :data="tableData" :span-method="arraySpanMethod" v-if="showTable" :id="tableId" style="width: 100%" size="small" ref="tableData">
      <el-table-column :label="tableTitle" header-align="center">
        <template #header>
<!--          <el-input v-model="tableTitle" v-if="tableActiveState" size="mini"></el-input>-->
          <span>{{ tableTitle }}</span>
        </template>
        <el-table-column label="按航线分-计划运里" header-align="center">
          <el-table-column label="序号" type="index" header-align="center" align="center" width="100"></el-table-column>
          <el-table-column label="航线" header-align="center" prop="route" align="center" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.route" v-if="scope.row.inputShow && scope.$index === activeRowIndex || tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" size="mini"></el-input>
              <span v-else>{{ getFormattedRoute(scope.row)}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="单价" header-align="center" prop="price" align="center" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <el-input v-model="scope.row.price" @input="handleInputPlan($event, scope)" v-if="scope.row.inputShow && scope.$index === activeRowIndex || tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" size="mini"></el-input>-->
<!--              <span v-else>{{ scope.row.price}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="数量" header-align="center" prop="number" align="center"></el-table-column>
<!--          <el-table-column label="总金额" header-align="center" prop="totalAmount" align="center"></el-table-column>-->
        </el-table-column>
        <el-table-column label="按品牌分-计划运里" header-align="center">
          <el-table-column :label="index + 1 + ''" header-align="center" v-for="(item, index) in brandHeaders">
            <el-table-column :label="item.name" header-align="center" :prop="item.prop" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row[item.prop]" @input="handleInputPlan($event, scope, item.prop)" v-if="scope.row.inputShow && scope.$index === activeRowIndex ||tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" size="mini"></el-input>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="备注" prop="notes" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.notes" v-if="scope.row.inputShow && scope.$index === activeRowIndex || tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" size="mini"></el-input>
            <span v-else>{{ scope.row.notes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="180" v-if="!isShowBtn">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.isShow && tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" @click="handleClickInsertPlan(scope)" type="primary" size="mini">添加</el-button>
            <el-button v-if="!tableActiveState&&scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" @click="handleClickUpdatePlan(scope.$index)" type="primary" size="mini">修改</el-button>
            <el-button v-if="scope.row.isShow && scope.$index === activeRowIndex || !tableActiveState && tableActiveState && scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" @click="handleClickSavePlan(scope)" type="primary" size="mini">保存</el-button>
            <el-button v-if="scope.$index != tableData.length - 1 && scope.$index != tableData.length - 2" @click="handleClickDeletePlan(scope)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <!-- 设置品牌 -->
    <el-drawer :visible.sync="drawer" :title="this.Title === 0 ? '新增品牌' : '修改品牌'" :size="800" v-loading='importLoading'>
      <el-row v-for="(item, index) in localBrandHeaders" :key="index" :gutter="20" style="margin-bottom: 10px">
        <el-col :span="9">
          <div style="display: flex; font-size: 12px; align-items: center; margin-left: 10px">
            <span>品牌名：</span>
            <el-input v-model="item.name" placeholder="请输入品牌名" @change="getBrandNames" :disabled="item.isDisabled" size="mini" style="flex: 1"></el-input>
          </div>
        </el-col>
        <el-col :span="9">
          <div style="display: flex; font-size: 12px; align-items: center">
            <span>品牌标识：</span>
            <el-input v-model="item.prop" placeholder="请输入品牌标识" @change="getBrandIds" :disabled="item.isBrandDisabled" size="mini" style="flex: 1"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <el-button @click="handleClickInsertBrand(index)" size="mini" type="primary" icon="el-icon-plus" circle :disabled="isAddDisabled"/>
          <el-button @click="handleClickEditBrand(index)" size="mini" type="primary" icon="el-icon-edit" circle v-if="Title == 1"/>
          <el-button @click="handleClickDeleteBrand(item,index)" size="mini" type="danger" icon="el-icon-delete" circle/>
          <el-button @click="handleClickSaveBrand(index)" size="mini" type="success" icon="el-icon-success" circle v-if="item.showSaveButton"/>
        </el-col>
      </el-row>
      <el-button size="small" type="primary" :loading="loading" style="margin-left: 500px;" @click="saveClick" v-if="Title === 0">保存</el-button>
    </el-drawer>
  </div>
<!--  <div v-else>error</div>-->
</template>

<script>
import {
  addColumn,
  addColumnMore,
  delColumn, delData,
  getComment,
  getTableDatas,
  saveData,
  updateColumn, updateTableData
} from "@/service/vehiclelog";
import * as XLSX from "xlsx";
import FileSaver from 'file-saver'



  export default {
    props: {
      rowData: Object,
      tableName: String,
      fieldName: String,
      default: () => {
        return {
          title: 'title',
          auditStatus: 'auditStatus'
        };
      },
    },
    data() {
      return {
        planType: 0,
        tableLoading: false,
        searchForm: {
          title: '',
          page: 1,
          rows: 10,
        },
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        selectedData: [],
        total: 0,
        tableTitle: '',
        brandHeaders: [{ name: '', prop: '' }],
        localBrandHeaders: [{ name: '', prop: '' }],
        tableData: [
          { route: '', number: '', notes: '' },
          { route: '下水小计', number: '', caft: '', calk: '', notes: '' },
          { route: '品牌占比', number: '', caft: '', calk: '', notes: '' },
        ],
        showTable: false,
        tableId: 'tableId',
        tableActiveState: false,
        isShowBtn: false,
        inputShow: false,
        btnState: false,
        drawer: false,
        Title: 0,
        importLoading: false,
        isNew: false,
        pageState: 2, // 1 - 主页面   2 - 编辑页面
        activeRowIndex: '',
        loading: false,
        isDisabled: false,
        isBrandDisabled: false,
        isAddDisabled: false,
        showSaveButton: false,
        isShow: false,
        brandNames: '',
        brandIds: '',
        title: this.rowData.title,
        auditStatus: this.rowData.auditStatus,
        dataSource: ''
      };
    },
    mounted() {
      this.getType()
      this.getTableData()
      this.showBtn()
      this.tableTitle = this.title
    },
    methods: {
      typeFun(val) {
        this.planType = val;
        this.getType()
        this.getTableData()
      },
      showBtn(){
        if(this.auditStatus == 1|| this.auditStatus == 2){
          this.isShowBtn = true
        }
      },
      //获取品牌名称及标识
      async getType() {
        this.importLoading = true
        const obj = {
          tableName: this.$props.tableName
        }
        const res = await getComment(obj)
        if (res.status == -1) return this.$message.warning(res.message);
        this.importLoading = false
        this.brandHeaders = res.data.map((item) => {
          return {
            prop: item.column,
            name: item.comment,
          }
        })
      },
      //详情-保存
      async handleClickSave() {
        this.loading = true
        const datas = []
        this.tableData.forEach(item => {
          if (item.route !== '上水小计' && item.route !== '下水小计' && item.route !== '品牌占比') {
            const data = {
              route: item.route,
              create_bz: item.notes,
            };
            this.brandHeaders.forEach(header => {
              const columnName = header.prop.trim();
              data[columnName] = item[columnName];
            });
            datas.push(data);
          }
        });
        // const  yearMonthAlls = [];
        // this.tableData.forEach(item => {
        //   if (item.route !== '上水小计' && item.route !== '下水小计' && item.route !== '品牌占比') {
        //     const route = item.route
        //     const price = item.price
        //     this.brandHeaders.forEach(header => {
        //       const brandProp = header.prop.trim();
        //       const numberCount = Number(item[brandProp])
        //       const brand = header.name
        //       yearMonthAlls.push({route,price, brand, numberCount});
        //     });
        //   }
        // });
        // let data2 = {title: this.title,typeName:this.$props.fieldName === 'launchedName'  ? '下水' : '上水', yearMonthAlls}
        const res = await saveData({datas, tableName: this.$props.tableName})
        if (res.status !== -1) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this.loading = false
        this.countTotals()
        await this.getTableData()
      },
      //获取表格数据
      async getTableData() {
        this.tableLoading = true
        const obj = {
          tableName: this.$props.tableName
        }
        const res = await getTableDatas(obj)
        if (res.status == -1) return this.$message.warning(res.message);
        if(res.data.length > 0){
          const data = res.data.map(item=>({
            'notes': item.create_bz,
            ...item
          }))
          this.tableData = data.concat(this.tableData.slice(-2))
        }
        setTimeout(()=>{
          this.countTotals()
          this.tableLoading = false
          this.showTable = true
        },1000)
      },
      getBrandNames(val){
        this.brandNames = val
      },
      getBrandIds(val){
        this.brandIds = val
      },
      getFormattedRoute(row) {
        if (row.route === '下水小计' || row.route === '上水小计') {
          return this.$props.fieldName === 'launchedName'  ? '下水小计' : '上水小计';
        }
        return row.route;
      },
      searchBtn() {},
      resetBtn() {},
      addBtn() {},
      exportData() {
        const filename = this.title;
        let tableDom = document.querySelector("#tableId").cloneNode(true);
        let tableHeader = tableDom.querySelector('.el-table__header-wrapper');
        let tableBody = tableDom.querySelector('.el-table__body');
        tableHeader.childNodes[0].append(tableBody.childNodes[1]);
        // 清理表头中的操作列
        let headerDom = tableHeader.childNodes[0].querySelectorAll('th');
        for (let key in headerDom) {
          if (headerDom[key].innerText === '操作') {
            headerDom[key].remove();
          }
        }
        // 清理表格中的操作按钮
        let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll('td,.cell');
        for (let key = 0; key < tableList.length; key++) {
          if (tableList[key].querySelectorAll('.el-button').length > 0) {
            tableList[key].remove();
          }
        }
        let webBook = XLSX.utils.table_to_book(tableDom);
        let sheetName = webBook.SheetNames[0];
        let sheet = webBook.Sheets[sheetName];
        if (sheet) {
          let range = XLSX.utils.decode_range(sheet['!ref']);
          let wscols = [];
          // 设置列宽
          for (let col = range.s.c; col <= range.e.c; col++) {
            wscols.push({ wch: 12 }); // 设置列宽
          }
          sheet['!cols'] = wscols;
          // 文字居中
          for (let col = range.s.c; col <= range.e.c; col++) {
            let colIndex = XLSX.utils.encode_col(col);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
              let cellAddress = colIndex + row;
              let cell = sheet[cellAddress];
              if (!cell) {
                continue;
              }
              if (!cell.s) {
                cell.s = {};
              }
              if (!cell.s.alignment) {
                cell.s.alignment = {};
              }
              cell.s.alignment.horizontal = 'center';
              cell.s.alignment.vertical = 'center';
            }
          }
        }
        let webOut = XLSX.write(webBook, {bookType: 'xlsx', bookSST: true, type: 'array'});
        try {
          FileSaver.saveAs(new Blob([webOut], { type: 'application/octet-stream' }), `${filename}.xlsx`);
        } catch (e) {
          if (typeof console !== 'undefined') console.log(e, webOut);
        }
        return webOut;
      },
      btnClick(type) {},
      goBack() {
        // console.log('go back');
        this.$emit('changePage', 1);
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      handleChangeActiveState() {
        this.tableActiveState = !this.tableActiveState;
        // console.log(this.tableData);
      },
      //新增品牌
      handleClickAddBrand() {
        this.$forceUpdate()
        this.$nextTick(()=>{
          this.Title = 0
          this.drawer = true
        })
      },
      //修改品牌
     async handleClickUpdateBrand(){
       this.$forceUpdate()
       this.$nextTick(()=>{
         this.Title = 1
         this.drawer = true
       })
        const obj = {
          tableName: this.$props.tableName
        }
        const res =  await getComment(obj)
       if (res.status == -1) return this.$message.warning(res.message);
       this.localBrandHeaders = res.data.map((item)=>{
         return {
           prop: item.column,
           name: item.comment,
           isDisabled: true,
           isBrandDisabled: true
         }
       })
      },
      //新增
      handleClickInsertBrand(index) {
        if (this.Title === 0) {
          this.localBrandHeaders.splice(index + 1, 0, { name: '', prop: '' });
        } else if(!this.isAddDisabled){
          this.localBrandHeaders.push({ name: '', prop: '' });
          this.isAddDisabled = true
          this.localBrandHeaders[index+1].showSaveButton = true
        }
      },
      //修改
      handleClickEditBrand(index) {
        // 然后取消其他行的禁用状态，并且只保持对应行的保存按钮显示
        for (let i = 0; i < this.localBrandHeaders.length; i++) {
          if (i !== index) {
            this.localBrandHeaders[i].isDisabled = true;
            this.isAddDisabled = false
          } else {
            // 对应行的保存按钮显示，取消禁用状态
            this.localBrandHeaders[i].isDisabled = false;
            this.localBrandHeaders[i].showSaveButton = true
          }
        }
      },
      //删除
      handleClickDeleteBrand(item,index) {
        if(this.Title === 0){
          this.localBrandHeaders.splice(index, 1);
          if (!(this.brandHeaders.length > 0)) {
            this.brandHeaders.splice(0, 0, { name: '', prop: '' });
          }
        }else {
          this.$confirm('确认删除当前数据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.importLoading = true
            const { status, message } = await delColumn({
              comment: item.name,
              column: item.prop,
              tableName:this.$props.tableName
            });
            if (status !== -1) return this.$message.warning(message);
            this.$message.success(message);
            await this.handleClickUpdateBrand()
            this.importLoading = false
            this.brandHeaders = [...this.localBrandHeaders];
          });
        }
      },
      //详情-修改-保存
      async handleClickSaveBrand() {
        this.importLoading = true
        if(!this.isAddDisabled){
          const columnDtos = []
          this.localBrandHeaders.forEach(item =>{
            const comment = item.name
            const column = item.prop
            columnDtos.push({comment, column,tableName:this.$props.tableName})
          })
          const {
            status,
            message
          } = await updateColumn(columnDtos);
          if (status !== -1) return this.$message.warning(message);
          this.$message.success(message);
          await this.handleClickUpdateBrand()
          this.importLoading = false
          this.brandHeaders = [...this.localBrandHeaders];
        }else {
          const {
            status,
            message
          } = await addColumn({
            comment: this.brandNames,
            column: this.brandIds,
            tableName:this.$props.tableName
          });
          if (status !== -1) return this.$message.warning(message);
          this.$message.success(message);
          await this.handleClickUpdateBrand()
          this.importLoading = false
          this.isAddDisabled = false
          this.brandHeaders = [...this.localBrandHeaders];
        }
      },
      //详情-新增-保存
      async saveClick() {
          this.loading = true
          const columnDtos = []
          this.localBrandHeaders.forEach((item) => {
            const comment = item.name
            const column = item.prop
            columnDtos.push({comment, column,tableName:this.$props.tableName})
          })
          this.loading = false
          const res = await addColumnMore(columnDtos)
          if (res.status !== -1) return this.$message.warning(res.message);
          this.$message.success(res.message);
          this.drawer = false;
          this.brandHeaders = [...this.localBrandHeaders];
      },
      handleClickInsertPlan(scope) {
        this.tableData.splice(scope.$index + 1, 0, {});

      },
      //详情-删除
      handleClickDeletePlan(scope) {
        this.tableData.splice(scope.$index, 1)
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const id = []
          id.push(parseInt(scope.row.id))
          this.tableLoading = true
          const {status, message} = await delData({
            tableName: this.$props.tableName,
            id
          });
          if (status !== -1) return this.$message.warning(message);
          this.tableLoading = false
          this.$message.success(message);
          await this.getType()
          await this.getTableData()
          if (!(this.tableData.length > 2)) {
            this.tableData.splice(0, 0, {});
          }
        });
      },
      //详情-修改
      handleClickUpdatePlan(scope){
        this.activeRowIndex = scope;
        this.tableData.forEach((row, index) => {
          if(index<this.tableData.length -2){
            if (index === scope) {
              row.inputShow = true;
              row.isShow = true;
              row.addShow = false
            } else {
              row.inputShow = false;
              row.isShow = false;
              row.addShow = true
            }
          }
        });
        this.tableActiveState = true
      },
      //详情-修改表格-保存
      async handleClickSavePlan(scope) {
        this.tableLoading = true
        const datas = []
        this.tableData.forEach(item => {
          if (scope.row.id === item.id) {
            const data = {
              route: item.route,
              create_bz: item.notes,
              id: item.id,
            };
            this.brandHeaders.forEach(header => {
              const columnName = header.prop.trim();
              data[columnName] = item[columnName];
            });
            datas.push(data);
          }
        });
        const dataSource = Object.assign({}, ...datas)
        const res = await updateTableData({
          dataSource,
          tableName: this.$props.tableName
        })
        if (res.status !== -1) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this.tableLoading = false
        await this.getTableData()
        this.countTotals()
        this.isShow = false
        this.tableActiveState = false
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === this.tableData.length - 1 || rowIndex === this.tableData.length - 2) {
          if (columnIndex === 0) {
            return [0, 0];
          } else if (columnIndex === 1) {
            return [1, 2];
          }
        }
      },
      handleInputPlan(value, scope, col) {
        this.countTotals();
      },
      countTotals() {
        this.tableData.forEach((row, i) => {
          if (i != this.tableData.length - 1 && i != this.tableData.length - 2) {
            let num = 0;
            Object.keys(row).forEach(colKey => {
              if (colKey != 'route' && colKey != 'number'  && colKey!= 'id' && colKey!= 'notes' && colKey !='create_time'
                && colKey !='create_by' && colKey !='create_bz' && colKey !='isShow' && colKey !='inputShow') {
                if (Boolean(Number(row[colKey]))) num += Number(row[colKey]);
              }
            });
            this.tableData[i]['number'] = num;
          }
        });

        let numberAddTo = 0;
        this.tableData.forEach((row, i) => {
          if (i != this.tableData.length - 1 && i != this.tableData.length - 2) {
            numberAddTo += Number(row['number']);
          }
        });
        this.tableData[this.tableData.length - 2]['number'] = numberAddTo;

        // let allAmount = 0;
        // this.tableData.forEach((row, i) => {
        //   if (i !== this.tableData.length - 1) {
        //     if(Number(row.price) && Number(row.number)) {
        //       allAmount = row.price * row.number;
        //     }
        //     this.tableData[i]['totalAmount'] = allAmount;
        //   }
        // });
        //
        // let allTotalAmount = 0;
        // this.tableData.forEach((row, i) => {
        //   if (i !== this.tableData.length - 1 && i !== this.tableData.length - 2) {
        //     allTotalAmount += Number(row['totalAmount']);
        //   }
        // });
        // this.tableData[this.tableData.length - 2]['totalAmount'] = allTotalAmount;


        this.brandHeaders.forEach(rowCol => {
          let colAddTo = 0;
          this.tableData.forEach((row, i) => {
            if (i != this.tableData.length - 1 && i != this.tableData.length - 2) {
              if (Boolean(Number(row[rowCol.prop]))) colAddTo += Number(row[rowCol.prop]);
            }
          });
          this.tableData[this.tableData.length - 2][rowCol.prop] = colAddTo;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.mainContainer {
  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 160px;
    margin-bottom: 20px;

    div {
      //background: #ccc;
      width: 90px;
      height: 30px;
      line-height: 30px;
      color: #48599e;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599e;
      font-weight: 700;
      transition: all 0.3s;
    }

    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .right {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .active {
      background: #48599e;
      color: #fff;
    }
  }

  .btn {
    margin-left: 10px;
  }
}
</style>
